import { FunctionComponent } from "react"
import { RootState, useTypedSelector } from "../../../app/store"
import ChooseAction from "./choose-action"
import DecisionTreeAndSearch from "./decisions-tree-and-search"

const DecisionPanel: FunctionComponent = () => {
  const decisionsStore = useTypedSelector((state: RootState) => {
    return state.decisionsSlice
  })

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0 overflow-hidden">
      {!decisionsStore.addConnectionOpenFlag && (
        <div className="flex-shrink-0">
          <ChooseAction />
        </div>
      )}
      {decisionsStore.activeChoiceType && <DecisionTreeAndSearch />}
    </div>
  )
}

export default DecisionPanel
